var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowScreentime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256.321,
    height: 181.678,
    viewBox: "0 0 256.321 181.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -37.534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.1,699.031c-1.11-1.4-2.574,1.387-4.038.356h8.115C580.524,700.3,579.234,697.532,578.1,699.031Z",
    transform: "translate(-388.274 -481.727)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.54,700.852h1.4c-.3.211-.6.421-.889.65C656.886,701.28,656.711,701.068,656.54,700.852Z",
    transform: "translate(-493.394 -483.192)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.015,696.125a13.391,13.391,0,0,1,6.511,1.682H537.521A13.333,13.333,0,0,1,544.015,696.125Z",
    transform: "translate(-343.619 -480.148)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.473,691.4a18.4,18.4,0,0,1,10.628,3.365H596.859A18.4,18.4,0,0,1,607.473,691.4Z",
    transform: "translate(-432.314 -477.103)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.524,579.31A41.527,41.527,0,0,1,742,570.554c.5-.018,1.006-.038,1.513-.038a41.536,41.536,0,0,1,39.843,29.82,29.349,29.349,0,0,1,34.827,8.67H688.645a28.09,28.09,0,0,1-28.151-29.084Q660.507,579.616,660.524,579.31Z",
    transform: "translate(-660.47 -392.129)",
    fill: "#e4efff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 127.129,
    height: 0.712,
    transform: "translate(123.211 217.303)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.668,372.7s13.716-4.272,11.61,2.757-13.658,3.479-13.658,3.479Z",
    transform: "translate(-187.338 -271.011)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.439,293.368s7.029-9.605,13.858.366c6.842,9.992,13.2,18.194,13.2,18.194l16.994,5.541,9.832.872-2.708,8.741-28.586-4.147S443.207,304.03,452.439,293.368Z",
    transform: "translate(-268.538 -218.065)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.494,450.352s10.678,7.475,9.966,14.237-5.339,25.271-5.339,25.271l-9.61-1.424S499.443,474.2,503,468.861l-17.085-9.61Z",
    transform: "translate(-290.219 -321.854)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.847,499.852s.712,13.169-1.068,18.509-3.559,25.271-3.559,25.271h-9.966s-4.627-17.441,1.068-25.271c0,0,1.78-10.322-3.2-15.305Z",
    transform: "translate(-405.242 -353.735)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.789,392.2s23.136,14.593,23.136,19.221l-18.508,15.305-6.407-7.119.712,10.678L515.789,434.2s-7.119-27.051-6.763-28.119,1.424-16.729,1.424-16.729Z",
    transform: "translate(-342.87 -282.566)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.5,552.352l10.322,2.136-1.834,7.539a26.923,26.923,0,0,0-.3,11.325h0s-10.678,2.847-10.678,1.424,2.491-7.119,1.78-11.034S501.5,552.352,501.5,552.352Z",
    transform: "translate(-291.213 -387.549)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.616,614.4c.356-1.424,3.313-7.879,3.436-6.787s5.818,2.872,7.954.736c0,0,2.848-2.492,3.915,0s3.2,6.763,3.2,6.763,9.61,4.627,8.187,7.119c-.288.5-1.086.716-2.175.735a.579.579,0,0,1,.039.206v.252a.586.586,0,0,1-.586.586h-.252a.586.586,0,0,1-.586-.586v-.252a.579.579,0,0,1,.064-.261c-.291-.025-.593-.059-.9-.1a.581.581,0,0,1,.128.361v.252a.586.586,0,0,1-.586.586H489.2a.586.586,0,0,1-.586-.586v-.252a.583.583,0,0,1,.3-.51c-.819-.137-1.674-.311-2.525-.5a.581.581,0,0,1,.086.3v.252a.586.586,0,0,1-.586.586h-.252a.586.586,0,0,1-.586-.586v-.252a.585.585,0,0,1,.348-.535c-.638-.155-1.263-.318-1.858-.478a.581.581,0,0,1,.086.3V622a.586.586,0,0,1-.586.586H482.8a.586.586,0,0,1-.586-.586v-.252a.584.584,0,0,1,.412-.556c-2.09-.589-3.615-1.1-3.615-1.1s-1.771-.645-3.915-1.515v.217a.586.586,0,0,1-.586.586h-.252a.586.586,0,0,1-.586-.586v-.252a.582.582,0,0,1,.227-.459c-.431-.181-.865-.367-1.294-.556v.2a.586.586,0,0,1-.586.586h-.252a.586.586,0,0,1-.586-.586v-.252a.584.584,0,0,1,.251-.479c-.464-.217-.912-.433-1.324-.645,0,.019.006.037.006.057v.252a.586.586,0,0,1-.586.586h-.252a.586.586,0,0,1-.586-.586v-.252a.586.586,0,0,1,.469-.574C468.158,615.256,467.53,614.744,467.616,614.4Z",
    transform: "translate(-262.664 -422.901)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.513,617.064l11.276-.712s-.683,11.746.683,15.661.683,5.339.683,5.339l-9.909.712Z",
    transform: "translate(-411.213 -428.769)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.818,673.338c.051-1.467,1.6-8.4,1.946-7.354s6.289,1.6,7.932-.938c0,0,2.265-3.031,3.829-.816s4.543,5.946,4.543,5.946,10.364,2.522,9.491,5.256c-.177.553-.913.927-1.974,1.172a.583.583,0,0,1,.082.194l.052.247a.586.586,0,0,1-.451.695l-.247.053a.586.586,0,0,1-.695-.451l-.053-.247a.576.576,0,0,1,.008-.269c-.29.036-.592.066-.9.091a.581.581,0,0,1,.2.327l.053.247a.586.586,0,0,1-.451.695l-.247.052a.585.585,0,0,1-.695-.451l-.053-.247a.583.583,0,0,1,.19-.562c-.83.037-1.7.045-2.574.034a.581.581,0,0,1,.147.277l.053.247a.586.586,0,0,1-.451.695l-.246.053a.586.586,0,0,1-.7-.451l-.053-.247a.585.585,0,0,1,.229-.6c-.656-.019-1.3-.047-1.916-.08a.58.58,0,0,1,.146.276l.053.247a.586.586,0,0,1-.451.7l-.247.052a.586.586,0,0,1-.7-.451l-.052-.247a.583.583,0,0,1,.287-.63c-2.167-.14-3.765-.319-3.765-.319s-1.866-.261-4.145-.665l.045.213a.586.586,0,0,1-.451.695l-.247.053a.586.586,0,0,1-.7-.451l-.053-.247a.583.583,0,0,1,.126-.5c-.459-.087-.922-.179-1.382-.274l.042.2a.586.586,0,0,1-.451.695l-.247.053a.586.586,0,0,1-.7-.451l-.053-.247a.585.585,0,0,1,.145-.521c-.5-.115-.982-.233-1.43-.355.006.018.013.035.018.054l.053.247a.586.586,0,0,1-.451.695l-.247.053a.586.586,0,0,1-.7-.451l-.053-.247a.586.586,0,0,1,.339-.659C546.526,674.064,545.805,673.694,545.818,673.338Z",
    transform: "translate(-369.657 -459.084)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.322,
    cy: 10.322,
    rx: 10.322,
    ry: 10.322,
    transform: "translate(183.596 42.718)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.894,235.352s-5.695,7.119-8.542,6.763l12.458,9.61s1.424-6.051,3.2-6.763S587.894,235.352,587.894,235.352Z",
    transform: "translate(-403.23 -183.38)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.008,297.049s0-39.276,6.589-42.659,10.941-5.311,10.941-5.311h0a9.239,9.239,0,0,0,3.552,6.609c2.183,1.686,4.359,3.083,5.574,3.088l.039-.167.148-.423,3.589,5.584s3.2.712,4.271,2.847c.578,1.155-2.147,12.786-.534,23.314,1.368,8.932,7.133,16.994,7.3,17.975.276,1.657-6.731-2.684-9.886-4.714-.047.052-.08.087-.08.087s1.78.712-1.78-.356a23.217,23.217,0,0,0-6.9-.554c0,.618-.012,1.11-.045,1.444-.356,3.559-18.153,8.542-20.644,7.475S546.008,297.049,546.008,297.049Z",
    transform: "translate(-383.59 -192.22)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.045,421.852s10.678,9.61,3.559,11.39-9.966-9.966-9.966-9.966Z",
    transform: "translate(-442.169 -303.498)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.971,486.654s-4.983-4.627-7.83-2.136-4.627,4.271-4.627,4.271S600.7,483.807,604.971,486.654Z",
    transform: "translate(-417.637 -343.385)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.171,644.47s-2.809-2.608-4.414-1.2-2.608,2.407-2.608,2.407S600.764,642.866,603.171,644.47Z",
    transform: "translate(-417.132 -445.836)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.814,574.571s-1.928-3.313-3.872-2.436-3.2,1.544-3.2,1.544S512.978,572.334,514.814,574.571Z",
    transform: "translate(-297.308 -400.195)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.456,270.97c3.528-7.092,14.264-3.224,12.519,4.5q-.039.173-.082.349a70.246,70.246,0,0,1-8.9,20.644l3.915,17.441,4.271,8.9-8.9,2.136-11.034-26.7S622.293,281.348,627.456,270.97Z",
    transform: "translate(-462.348 -203.918)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,156.065l6.763,25.627-5.695-12.1Z",
    transform: "translate(-279.751 -62.983)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.106,198.261s5.706-6.007,11.449-2.224,8.468,7.458,7.9,10.017a37.144,37.144,0,0,1-2.23,6.118s1.036-5.3-3.72-5.693-11.325-3.539-11.325-3.539l-4.444,9.491s-.628-2.2-2.37-1.568S537.979,198.965,543.106,198.261Z",
    transform: "translate(-355.67 -157.253)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.513,556.869a16.352,16.352,0,0,0,.224,2.691v0a16.021,16.021,0,0,0,22.153,12.006h0a15.639,15.639,0,0,0,1.911-.986,16.041,16.041,0,0,0,7.432-10.554,16.207,16.207,0,0,0,.31-3.161c0-.484-.021-.965-.064-1.438v0a16.016,16.016,0,0,0-31.966,1.221v0C399.513,556.727,399.513,556.794,399.513,556.869Z",
    transform: "translate(-175.518 -380.142)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.945,550.875h7.173l3.587-6.211-2.433-4.217-.142-.038a16.428,16.428,0,0,0-9.362.262l-.129.043-2.281,3.951Zm6.763-.712h-6.352l-3.176-5.5,1.94-3.359a15.788,15.788,0,0,1,8.684-.246l2.08,3.605Z",
    transform: "translate(-192.876 -379.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.945,584.339h7.173l3.587-6.212-3.587-6.213h-7.174l-3.587,6.213Zm6.763-.712h-6.352l-3.176-5.5,3.176-5.5h6.352l3.176,5.5Z",
    transform: "translate(-191.52 -400.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.643,617.721a16.225,16.225,0,0,0,6.5-1.347l.366-.159-3.637-6.3H428.7l-3.484,6.035.346.166A16.222,16.222,0,0,0,432.643,617.721Zm5.851-1.845a15.679,15.679,0,0,1-12.275-.242l2.892-5.01h6.352Z",
    transform: "translate(-192.631 -424.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.039,566.337h7.173l3.587-6.211-3.587-6.215h-3.266l-.105.111a16.3,16.3,0,0,0-4.483,11.032v.1Zm6.763-.712H459.45l-.378-.655a15.582,15.582,0,0,1,4.182-10.347H465.8l3.176,5.5Z",
    transform: "translate(-234.716 -388.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.091,603.163l3.488-6.037-3.587-6.215h-7.173l-.46.794.005.159a16.407,16.407,0,0,0,7.415,11.1Zm2.666-6.037-2.91,5.036a15.693,15.693,0,0,1-6.761-10.293l.142-.245h6.352Z",
    transform: "translate(-234.495 -412.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.906,603.317l.311-.188a16.414,16.414,0,0,0,7.6-10.788l.026-.132-.75-1.3h-7.174l-3.587,6.214Zm7.183-10.985a15.7,15.7,0,0,1-6.931,10l-3.006-5.2,3.176-5.5h6.352Z",
    transform: "translate(-154.745 -412.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.28,564.337h7.173l.976-1.687v-.1a16.325,16.325,0,0,0-5.157-10.548l-.1-.1h-2.89l-3.587,6.215Zm6.763-.712h-6.352l-3.176-5.5,3.176-5.5h2.2a15.6,15.6,0,0,1,4.82,9.85Z",
    transform: "translate(-154.109 -387.265)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowScreentime);
export default __webpack_public_path__ + "static/media/low_screentime.e9b98686c1ddd2d26b2d5d98d0470364.svg";
export { ForwardRef as ReactComponent };